import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Constants from "../../../../common/Constants";
import ItemService from "../../../../services/commonService";
import toast from "react-hot-toast";
import MasterList from "../../../common/MasterList";
import Form from "react-bootstrap/Form";
import DataTable from "react-data-table-component";
import { AlertModal } from "../../../common/AlertModal";

const OkQuantityModal = (props) => {

  const { t } = useTranslation();
  // const [inputValue, setInputValue] = useState("");
  const [reasonsList, setReasonsList] = useState("");
  const [switchValue, setSwitchValue] = useState(false);
  const [addedRowsData, setAddedRowsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isAlert, setIsAlert] = useState(false);


  const handleCancel = () => {
    props.onHide();
  };
  // const handleInputChange = (event) => {
  //   setInputValue(event.target.value);
  // };
  // const handleClick = () => {
  //   props.onButtonClick(inputValue, "from");
  // };
  const handleSwitchChange = (event) => {
    if(event.target.checked) {
      props.getWeighingScaleData(event.target.checked);
    } else {
      setSwitchValue(event.target.checked);
    }
  };
  const resetAlert = () => {
    setIsAlert(false);
  };

  const deleteReasons =(row) => {
    if(addedRowsData) {
      const updatedData = addedRowsData.filter(item => item.reasonCode !== row.reasonCode);
      setAddedRowsData(updatedData)
      const totalCount = updatedData?.reduce(
        (total, item) => total + Number(item.count),
        0
      );
    setTotalCount(totalCount);
    }
  }
  const addReasons = (row) => {
    if(!row?.count) {
      setIsAlert(true)
      return
    }
    let updatedData =[] ;
    if (addedRowsData.length > 0 ) {
      updatedData = addedRowsData.map((item) => {
        if (item.reasonCode === row.reasonCode) {
          return {
            ...item,
            count: Number(item.count) + Number(row.count),
          };
        }
        return item;
      });

      const existingItem = updatedData.find(
        (item) => item.reasonCode === row.reasonCode
      );

      if (!existingItem) {
        // If the reasonCode wasn't found, add a new entry
        updatedData.push({
          slNo: addedRowsData.length + 1, // Set the correct serial number
          reasonName: row.reasonName,
          actualWt: "0",
          unitWt: "0",
          count: row.count,
          reasonCode: row.reasonCode,
          jobstatus:props.jobStatusCode
        });
      }

      setAddedRowsData(updatedData);
    } else {
      // If there are no records, insert the first record
       const newData = {
        slNo: 1,
        reasonName: row.reasonName,
        actualWt: "0",
        unitWt: "0",
        count: row.count,
        reasonCode: row.reasonCode,
        jobstatus:props.jobStatusCode
      };

      updatedData.push(newData);
      setAddedRowsData(updatedData);
    }
      const totalCount = updatedData?.reduce(
        (total, item) => total + Number(item.count),
        0
      );
    setTotalCount(totalCount);
  };
  useEffect(() => {
    loadAllReasons();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadAllReasons = async () => {
    let param = {};
    param.url = "getReasonDataByJobIdDeptCode";
    param.page = Constants.MASTER.REASON.name;
    param.id = props.jobStatusCode;
    param.deptCode = props.deptCode;

    await ItemService.getMasterListDataById(param).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setReasonsList(item?.data);
      } else {
        toast.error(item?.message || "Please try again ", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  const handleOk =() => {
    if(totalCount !== 0) {
      props.accumulateActualValue(totalCount,props.jobStatusCode,addedRowsData);
      onHide();
    } else {
      setIsAlert(true);
    }
  }

  const columnsData = [
    {
      name: "Reasons",
      selector: (row) => row.reasonName,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reasonName} </p>
        </div>
      ),
    },
    {
      name: "Acutal Wt.",
      selector: (row) => row.actualWt,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div className="popupInputField">
          <input
            type="number"
            value={0}
            onChange={(e) => (row.actualWt = e.target.value)}
            disabled={switchValue ? false : true}
          />
        </div>
      ),
    },
    {
      name: "Unit Wt.",
      selector: (row) => row.unitWt,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div className="popupInputField">
          <input
            type="number"
            value={0}
            onChange={(e) => (row.unitWt = e.target.value)}
            disabled={switchValue ? false : true}
          />
        </div>
      ),
    },
    {
      name: "Count",
      selector: (row) => row.count,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div className="popupInputField">
          <input
            type="number"
            width={50}
            onChange={(e) => {
              if(e.target.value) {
                row.count = e.target.value
              }
            }}
          />
        </div>
      ),
    },
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-plus-circle iconTable"
              onClick={() => addReasons(row)}
            ></i>
          </span>
        </>
      ),
      width: "100px",
    },
  ];

  const addedColumnsData = [
    {
      name: "SlNo.",
      selector: (row) => row.slNo,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.slNo} </p>
        </div>
      ),
    },
    {
      name: "Reasons",
      selector: (row) => row.reasonName,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reasonName} </p>
        </div>
      ),
    },
    {
      name: "Acutal Wt.",
      selector: (row) => row.actualWt,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.actualWt} </p>
        </div>
      ),
    },
    {
      name: "Count",
      selector: (row) => row.count,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.count} </p>
        </div>
      ),
    },
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i className="bi bi-trash3 iconTable"
             onClick={() => deleteReasons(row)}
             ></i>
          </span>
        </>
      ),
      width: "100px",
    },
  ];

  const { show, onHide, title } = props;
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card>
          <Card.Header>
            <Form className="automanual">
              <strong>Manual &nbsp;</strong>
              <Form.Check // prettier-ignore
                type="switch"
                id="custom-switch"
                label="Auto"
                checked={switchValue} // Bind the state to the checked prop
                onChange={handleSwitchChange} // Handle change event
              />
            </Form>
          </Card.Header>
          <Card.Body>
            <Row className="ps-3 start-stop-page-header">
              <Col lg={6} md={6} sm={12}>
                <MasterList
                  columnsData={columnsData}
                  rowsData={reasonsList}
                  paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                  pagination={false}
                  selectableRows={false}
                  handleClose
                  cardHeader={false}

                  // handleOpen={handleOpen}
                  // handleDelete={confirmBeforeDelete}
                  // onSelectedRowsChange={handleRowSelected}
                />
              </Col>
              <Col lg={6} md={6} sm={12}>
                <Card>
                  <Card.Body>
                    <DataTable
                      columns={addedColumnsData}
                      data={addedRowsData}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="ps-3 start-stop-page-header">
              <Col md={{ span: 6, offset: 6 }}>
                <strong>{`Total Count : ${totalCount}`}</strong>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer>
            <Button
              type="button"
              variant="success"
              className="btn btn-success"
              onClick={() => handleOk()}
            >
              {t("msg_common.save")}
            </Button>
            <Button
              type="button"
              variant="danger"
              className="btn btn-danger"
              onClick={handleCancel}
              data-dismiss="modal"
            >
              {t("msg_common.cancel")}
            </Button>
          </Card.Footer>
        </Card>
        {isAlert && (
          <AlertModal
            show={isAlert}
            heading={t("msg_common.alert")}
            bodyMessage={"Please Enter Count Value"}
            onHide={() => {
              resetAlert();
            }}
          ></AlertModal>
        )}
      </Modal.Body>
    </Modal>
    
  );
};

export default OkQuantityModal;
